import type React from 'react'
import { createContext, useContext } from 'react'
import type { CoachOnboardingStep } from '../hooks/useCoachOnboarding'
import { useCoachOnboarding } from '../hooks/useCoachOnboarding'

interface CoachOnboardingContextType {
  run: boolean
  steps: CoachOnboardingStep[]
  stepIndex: number
  loading: boolean
  setStepIndex: (index: number) => void
  setRun: (run: boolean) => void
  completeOnboarding: () => Promise<void>
  resetOnboarding: () => Promise<void>
  startTour: () => void
  stopTour: () => void
}

const CoachOnboardingContext = createContext<CoachOnboardingContextType | undefined>(undefined)

export const useCoachOnboardingContext = () => {
  const context = useContext(CoachOnboardingContext)
  if (context === undefined) {
    throw new Error('useCoachOnboardingContext must be used within a CoachOnboardingProvider')
  }
  return context
}

interface CoachOnboardingProviderProps {
  children: React.ReactNode
}

export const CoachOnboardingProvider: React.FC<CoachOnboardingProviderProps> = ({ children }) => {
  const onboarding = useCoachOnboarding()

  return <CoachOnboardingContext.Provider value={onboarding}>{children}</CoachOnboardingContext.Provider>
}
